// components/seller/VariantForm.tsx
import React from "react";
import { VariantFormData } from "../../types/seller.type";

interface VariantFormProps {
  variant: VariantFormData;
  index: number;
  onUpdate: (
    index: number,
    field: keyof VariantFormData,
    value: string | number,
  ) => void;
  onRemove: (index: number) => void;
  showRemove?: boolean;
}

const VariantForm: React.FC<VariantFormProps> = ({
  variant,
  index,
  onUpdate,
  onRemove,
  showRemove = true,
}) => {
  const units = ["g", "kg", "ml", "l", "piece", "pack", "box"];

  return (
    <div className="p-4 border border-gray-200 rounded-lg bg-gray-50">
      <div className="flex justify-between items-center mb-3">
        <h4 className="text-sm font-medium text-gray-700">
          Variant {index + 1}
        </h4>
        {showRemove && (
          <button
            type="button"
            onClick={() => onRemove(index)}
            className="text-red-500 hover:text-red-700"
          >
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        )}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Title
          </label>
          <input
            type="text"
            value={variant.title}
            onChange={(e) => onUpdate(index, "title", e.target.value)}
            placeholder="Title (e.g., product name)"
            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-green-500 focus:border-green-500"
            required
          />
        </div>

        <div className="grid grid-cols-2 gap-2">
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Unit
            </label>
            <select
              value={variant.unit}
              onChange={(e) => onUpdate(index, "unit", e.target.value)}
              className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-green-500 focus:border-green-500"
              required
            >
              <option value="">Select Unit</option>
              {units.map((unit) => (
                <option key={unit} value={unit}>
                  {unit}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Value
            </label>
            <input
              type="number"
              value={variant.value}
              onChange={(e) =>
                onUpdate(index, "value", parseInt(e.target.value) || 0)
              }
              placeholder="500"
              min="1"
              className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-green-500 focus:border-green-500"
              required
            />
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700">
            Price (₹)
          </label>
          <input
            type="number"
            value={variant.price}
            onChange={(e) =>
              onUpdate(index, "price", parseInt(e.target.value) || 0)
            }
            placeholder="120"
            min="0"
            step="1"
            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-green-500 focus:border-green-500"
            required
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700">
            MRP (₹)
          </label>
          <input
            type="number"
            value={variant.mrp}
            onChange={(e) =>
              onUpdate(index, "mrp", parseInt(e.target.value) || 0)
            }
            placeholder="120"
            min="0"
            step="1"
            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-green-500 focus:border-green-500"
            required
          />
        </div>

        {/* <div>
          <label className="block text-sm font-medium text-gray-700">SKU</label>
          <input
            type="text"
            value={variant.sku}
            onChange={(e) => onUpdate(index, "sku", e.target.value)}
            placeholder="BIO500"
            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-green-500 focus:border-green-500"
            required
          />
        </div> */}

        <div>
          <label className="block text-sm font-medium text-gray-700">
            Initial Stock123456
          </label>
          <input
            type="number"
            value={variant.stock}
            onChange={(e) =>
              onUpdate(index, "stock", parseInt(e.target.value) || 0)
            }
            placeholder="100"
            min="0"
            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-green-500 focus:border-green-500"
            required
          />
        </div>
      </div>
    </div>
  );
};

export default VariantForm;
